/**
 * Gesellschafts-Seite
 * Zeigt die Gesellschaftsstruktur und Kommanditisten des Projekts.
 */
import React from 'react';
import { ProjectDetailPageProps } from '../../../types';
import { useCompanyData } from './hooks/useCompanyData';
import PageTemplate from '../../layout/PageTemplate';
import CompanySection from './sections/CompanySection';
import ShareholdersSection from './sections/ShareholdersSection';

interface ProjectCompanyPageProps extends ProjectDetailPageProps {
  canView: boolean;
  canEdit: boolean;
}

const ProjectCompanyPage: React.FC<ProjectCompanyPageProps> = ({
  project,
  canEdit,
}) => {
  const {
    company,
    isLoading,
    isSaving,
    error,
    remainingPercent,
    totalPercent,
    updateCompanyField,
    createShareholder,
    updateShareholder,
    deleteShareholder,
    refetchCompany,
  } = useCompanyData({ projectId: project.id });

  return (
    <PageTemplate isLoading={isLoading} isSaving={isSaving} saveError={error}>
      <CompanySection
        company={company}
        canEdit={canEdit}
        isSaving={isSaving}
        onFieldChange={updateCompanyField}
      />

      <ShareholdersSection
        shareholders={company?.shareholders ?? []}
        totalPercent={totalPercent}
        remainingPercent={remainingPercent}
        canEdit={canEdit}
        isSaving={isSaving}
        error={error}
        onCreateShareholder={createShareholder}
        onUpdateShareholder={updateShareholder}
        onDeleteShareholder={deleteShareholder}
        onDataChanged={refetchCompany}
      />
    </PageTemplate>
  );
};

export default ProjectCompanyPage;
